import { CurrencyPipe, getCurrencySymbol } from '@angular/common';

export function formatCurrencyString(value?: string, currencyCode: string = 'USD'): string {
    if(isNaN(Number(value))) {
        const currencySymbol = getCurrencySymbol(currencyCode, 'narrow');
        return `${currencySymbol}0.00`;
    }

    const currencyPipe = new CurrencyPipe('en-US');
    let formattedValue = currencyPipe.transform(value, currencyCode, 'symbol', '1.2-2');
    if(!formattedValue) {
        const currencySymbol = getCurrencySymbol(currencyCode, 'narrow');
        formattedValue = `${currencySymbol}0.00`;
    }

    return formattedValue;
}